function routes($stateProvider) {
    $stateProvider
        .state('user.list', {
            name: 'userList',
            url: '/list',
            views: {
                'content': { template: '<user-list></user-list>' }
            }
        })
        .state('user.profile', {
            name: 'userProfile',
            url: '/my-profile',
            views: {
                'content': { template: '<my-profile></my-profile>' }
            }
        });
}

routes.$inject = [
    '$stateProvider'
];

export default routes;



// WEBPACK FOOTER //
// ./src/app/pages/user/userRoutes.js